import React from 'react';
import flow from 'lodash/flow';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import isTestEnv from '@signal/utils/env/isTest';
var toPascal = flow(camelCase, upperFirst);
export function getImportSvg() {
  // Process svgs through the `svgr/webpack` loader.
  // do not call require.context in a jest environment
  var importSvg = require.context('!@svgr/webpack!../svg', false, // No need to load files recursively.
  /^\.\/.*\.svg$/ // Match files ending with .svg.
  );

  return importSvg;
}
export var getSvg = function getSvg(name) {
  // return pascal case name for test env
  if (isTestEnv()) return function (props) {
    return /*#__PURE__*/React.createElement("svg", props, toPascal(name));
  };
  var importSvg = getImportSvg();
  return importSvg("./".concat(name, ".svg")).default;
};
export default getSvg;